import { defineStore } from "pinia";
import { Dibs } from "Scripts/types/dibs";

export const useNetsEasyCheckoutStore = defineStore("netsEasyCheckout", {
    state: () => ({
        checkoutOptions: {} as Dibs.CheckoutOptions | null | undefined,
        checkout: null as Dibs.Checkout | null | undefined,
        staleCheckoutInstance: false,
    }),    
    actions: {
        setCheckout(checkout: Dibs.Checkout | null | undefined) {
            this.checkout = checkout;
            this.staleCheckoutInstance = false;
        },
        setCheckoutOptions(options: Dibs.CheckoutOptions | null | undefined) {
            this.checkoutOptions = options;
            this.staleCheckoutInstance = true;
        },
    },
});